import { createContext, PropsWithChildren, useContext } from 'react';

const FormIdContext = createContext<string | undefined>(undefined);

export function FormIdProvider({ formId, children }: PropsWithChildren<{ formId: string }>) {
  return <FormIdContext.Provider value={formId}>{children}</FormIdContext.Provider>;
}

export const useFormId = () => useContext(FormIdContext);
